import actions from "@/store/historic/actions";
import mutations from "@/store/historic/mutations";
import state from "@/store/historic/state";
export default {
    actions,
    mutations,
    state
}